import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.755 3.348a1 1 0 0 1-.108 1.407l-5.25 4.5a1 1 0 0 1-1.288.009l-3.852-3.21-4.61 3.95A.997.997 0 1 1 3.348 8.49l5.25-4.5a1 1 0 0 1 1.288-.009l3.852 3.21 4.61-3.95a.997.997 0 0 1 1.407.107m-14.757 14.9c-.554 0-1-.48-1-1.072V13.32c0-.593.446-1.071 1-1.071.553 0 1 .478 1 1.071v3.857c0 .593-.447 1.072-1 1.072m3.5-1.072c0 .593.446 1.072 1 1.072.553 0 1-.48 1-1.072V10.32c0-.593-.447-1.071-1-1.071-.554 0-1 .478-1 1.071zm5.5 1.072c-.554 0-1-.48-1-1.072V11.82c0-.593.446-1.071 1-1.071.553 0 1 .478 1 1.071v5.357c0 .593-.447 1.072-1 1.072m3.5-1.072c0 .593.446 1.072 1 1.072.553 0 1-.48 1-1.072V10.32c0-.593-.447-1.071-1-1.071-.554 0-1 .478-1 1.071z",
      clipRule: "evenodd"
    }
  )
);
var SvgGraphFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var GraphFilled_default = SvgGraphFilled;

export { GraphFilled_default as default };
